import React from "react";
import { useQuery } from "@tanstack/react-query";
import AdminLayout from "@/components/admin/AdminLayout";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "@/components/ui/table";
import { listAdminContacts } from "@/lib/api";
import { Loader2 } from "lucide-react";

const Contacts = () => {
    const { data: contacts = [], isLoading } = useQuery({
        queryKey: ["admin", "contacts"],
        queryFn: listAdminContacts,
    });

    return (
        <AdminLayout>
            <div className="space-y-6">
                <div>
                    <h1 className="font-display text-3xl font-semibold tracking-tight">
                        Messages de contact
                    </h1>
                    <p className="text-neutral-500 mt-1">
                        Messages reçus via le formulaire de contact.
                    </p>
                </div>

                <div className="bg-white rounded-xl border border-neutral-200 overflow-hidden">
                    <Table>
                        <TableHeader>
                            <TableRow>
                                <TableHead>Date</TableHead>
                                <TableHead>Nom</TableHead>
                                <TableHead>Email</TableHead>
                                <TableHead>Sujet</TableHead>
                                <TableHead>Message</TableHead>
                            </TableRow>
                        </TableHeader>
                        <TableBody>
                            {isLoading ? (
                                <TableRow>
                                    <TableCell colSpan={5} className="text-center py-8">
                                        <Loader2 className="w-6 h-6 animate-spin mx-auto text-[#0a84ff]" />
                                    </TableCell>
                                </TableRow>
                            ) : contacts.length === 0 ? (
                                <TableRow>
                                    <TableCell colSpan={5} className="text-center py-8 text-neutral-500">
                                        Aucun message.
                                    </TableCell>
                                </TableRow>
                            ) : (
                                contacts.map((c) => (
                                    <TableRow key={c.id}>
                                        <TableCell className="text-sm text-neutral-500 whitespace-nowrap">
                                            {new Date(c.created_at).toLocaleString("fr-FR")}
                                        </TableCell>
                                        <TableCell className="font-medium">{c.full_name}</TableCell>
                                        <TableCell className="text-sm">{c.email}</TableCell>
                                        <TableCell>{c.subject || "—"}</TableCell>
                                        <TableCell>
                                            <div className="max-w-xs truncate text-sm">{c.message}</div>
                                        </TableCell>
                                    </TableRow>
                                ))
                            )}
                        </TableBody>
                    </Table>
                </div>
            </div>
        </AdminLayout>
    );
};

export default Contacts;
